import { commonErrorApiCodeRedblue } from "./errors-api-code-redblue";
import { commonErrorApiCodeResourcesRedblue } from "./errors-api-code-resources-redblue";

// Domain error-code dictionary, composed by the owning app transport.
// Assembled only from generated own namespaces, never from the monolithic catalog.
export const errorCodeDomain = {
  apiCodes: {
    ...commonErrorApiCodeRedblue,
  },
  apiCodeResources: {
    ...commonErrorApiCodeResourcesRedblue,
  },
  apiCodeReasons: {
  },
} as const;
